import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PersonalBusinessFinancesArticle = lazy(() => import('../pages/resources/articles/PersonalBusinessFinances'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const ComplaintOptInPage = lazy(() => import('../pages/complaint-opt-in/page'));
const TechAIFallingBehindArticle = lazy(() => import('../pages/resources/articles/TechAIFallingBehind'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/resources/personal-business-finances',
    element: <PersonalBusinessFinancesArticle />,
  },
  {
    path: '/resources/tech-ai-falling-behind',
    element: <TechAIFallingBehindArticle />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/complaint-opt-in',
    element: <ComplaintOptInPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
